import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiNewsFeedSharedService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared.service';
import {
    FiReadsUserType,
    FiUserInteractionsDialogComponent,
} from '@fi-shared/fi-news-feed-shared/fi-news-feed-buttons/fi-reads-count-button/fi-reads-user-list-data-dialog/fi-reads-user-list-data-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { ObjectTypes } from '@fi-shared/types';
import { IReactionModel } from '@fi-shared/fi-likes/fi-likes';
import { FiLikesService } from '@fi-app/shared/fi-likes/services/fi-likes.service';

@Component({
    selector: 'ccm-likes',
    templateUrl: './likes.component.html',
    styleUrls: ['./likes.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'ccm-likes' },
    standalone: false,
})
export class LikesComponent implements OnInit {
    @Input() item: {
        Reactions: IReactionModel[];
        ObjectId: number;
        ObjectType: ObjectTypes;
    };

    isShowInfo: boolean = false;
    likesToShowCount: number = 10;

    objectId: number;
    objectType: ObjectTypes;

    constructor(
        private appTextService: AppTextService,
        private newsFeedSharedService: FiNewsFeedSharedService,
        private fiDialogsService: FiDialogsService,
        private likesService: FiLikesService,
        private detectDeviceService: DetectDevicesService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        const objectItem = this.newsFeedSharedService.getObjectItem(this.item);
        this.objectId = objectItem.ObjectId;
        this.objectType = objectItem.ObjectType;
    }

    isLikesPopupShown() {
        return !this.detectDeviceService.isMobilePhone() && this.isShowInfo && this.item.Reactions.length;
    }

    toggleInfoShownStatus(newValue: boolean) {
        this.isShowInfo = newValue;
    }

    getLikeIconClass(): { [property: string]: boolean } {
        const isCurrentUserLiked = this.likesService.isCurrentUserLiked(this.item.Reactions);
        return {
            fas: isCurrentUserLiked,
            far: !isCurrentUserLiked,
            'current-user-liked': isCurrentUserLiked,
        };
    }

    getLikesCount(): number {
        return this.likesService.getLikesCount(this.item.Reactions);
    }

    getLikesRemainText(): string {
        if (this.item.Reactions?.length > this.likesToShowCount)
            return String.format(
                this.appTextService.get('and_others'),
                this.item.Reactions.length - this.likesToShowCount,
            );

        return null;
    }

    openDetailsDialog($event) {
        $event.stopPropagation();
        this.fiDialogsService.custom({
            hideFooter: true,
            hideHeader: true,
            contentComponentRef: FiUserInteractionsDialogComponent,
            contentComponentData: {
                objectId: this.objectId,
                objectType: this.objectType,
                readsUserType: FiReadsUserType.LikedBy,
                usersData: this.item.Reactions,
            },
            config: {
                panelClass: 'fi-reads-user-list-data-panel',
            },
        });
    }

    onLikesChanged($event: IReactionModel[]) {
        this.item.Reactions = $event;
        this.cdr.detectChanges();
    }
}
